module.exports = __webpack_public_path__ + "img/Great_Bittern.724d326e.png";